import { render, staticRenderFns } from "./TimelineBlock.vue?vue&type=template&id=23ca53bc"
import script from "./TimelineBlock.vue?vue&type=script&lang=js"
export * from "./TimelineBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports